import React, { ChangeEvent, Component } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { TextAnnotation } from '@paragon/contract-library';

import AnnotationOptionsSection, { AnnotationsOptionsRow } from './AnnotationOptionsSection';
import FloatInput from './FloatInput';

interface Props {
  readonly annotationBeingEdited: TextAnnotation | undefined;
}

interface State {
  readonly translationAreaEnabled: boolean;
  readonly drawTranslationAreaBorder: boolean;
  readonly translationAreaWidth: number;
  readonly translationAreaHeight: number;
}

export default class VariableOptions extends Component<Props, State> {
  state: State = {
    translationAreaEnabled: !!(this.props.annotationBeingEdited && this.props.annotationBeingEdited.translationArea),
    drawTranslationAreaBorder:
      this.props.annotationBeingEdited && this.props.annotationBeingEdited.translationArea
        ? this.props.annotationBeingEdited.translationArea.drawBorder || false
        : false,

    translationAreaWidth:
      this.props.annotationBeingEdited && this.props.annotationBeingEdited.translationArea
        ? this.props.annotationBeingEdited.translationArea.width
        : 0.0,
    translationAreaHeight:
      this.props.annotationBeingEdited && this.props.annotationBeingEdited.translationArea
        ? this.props.annotationBeingEdited.translationArea.height
        : 0.0,
  };

  onToggleTranslationAreaEnabled = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ translationAreaEnabled: event.target.checked });
  };

  onToggleDrawTranslationAreaBorder = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ drawTranslationAreaBorder: event.target.checked });
  };

  onWidthChange = (newWidth: number) => {
    this.setState({ translationAreaWidth: newWidth });
  };

  onHeightChange = (newHeight: number) => {
    this.setState({ translationAreaHeight: newHeight });
  };

  get updatedProperties() {
    if (this.state.translationAreaEnabled) {
      return {
        translationArea: {
          ...this.props.annotationBeingEdited?.translationArea,
          drawBorder: this.state.drawTranslationAreaBorder,

          width: this.state.translationAreaWidth,
          height: this.state.translationAreaHeight,
        },
      };
    }

    return { translationArea: null };
  }

  render() {
    const displayIfTranslationAreaEnabled = this.state.translationAreaEnabled ? {} : { display: 'none' };

    return (
      <AnnotationOptionsSection title="variable" titleMargin={7}>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                color="default"
                checked={this.state.translationAreaEnabled}
                onChange={this.onToggleTranslationAreaEnabled}
              />
            }
            label="Set Translation Area"
          />

          <FormControlLabel
            style={displayIfTranslationAreaEnabled}
            control={
              <Checkbox
                color="default"
                checked={this.state.drawTranslationAreaBorder}
                onChange={this.onToggleDrawTranslationAreaBorder}
              />
            }
            label="Draw Border"
          />
        </div>

        <AnnotationsOptionsRow>
          <FloatInput
            label="Width"
            onChange={this.onWidthChange}
            value={this.state.translationAreaWidth}
            style={displayIfTranslationAreaEnabled}
          />

          <FloatInput
            label="Height"
            onChange={this.onHeightChange}
            value={this.state.translationAreaHeight}
            style={displayIfTranslationAreaEnabled}
          />
        </AnnotationsOptionsRow>
      </AnnotationOptionsSection>
    );
  }
}
